import { render, staticRenderFns } from "./index_working_wall.vue?vue&type=template&id=2d1e10a6"
import script from "./index_working_wall.vue?vue&type=script&lang=js"
export * from "./index_working_wall.vue?vue&type=script&lang=js"
import style0 from "./index_working_wall.vue?vue&type=style&index=0&id=2d1e10a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports